export const DESIGN_WIDTH = 720;
export const DESIGN_HEIGHT = 1280;

export const CLOCK_CENTER_X = DESIGN_WIDTH / 2;
export const CLOCK_CENTER_Y = 700;
export const RIM_RADIUS = 248;
export const FACE_CANVAS_SIZE = 640;
export const MARKER_RADIUS = 244;

export const MINUTE_HAND_LENGTH = 224;
export const MINUTE_HAND_THICKNESS = 12;
export const MINUTE_BASE_SPEED = 96;

export const HOUR_HAND_LENGTH = 164;
export const HOUR_HAND_THICKNESS = 16;
export const HOUR_BASE_SPEED = 64;

export const HIT_WINDOW_DEG = 11;
export const SPEED_GAIN = 1.05;
export const SPEED_CAP = 4;
export const BOOST_MULTIPLIER = 1.5;
export const STUTTER_DURATION = 0.3;
export const STUTTER_MULTIPLIER = 0.32;
export const STUTTER_WOBBLE_DEG = 3.5;

export const SINGLE_HIT_POINTS = 100;
export const DOUBLE_HIT_BONUS = 300;
export const DOUBLES_PER_HEART = 3;
export const COMBO_HITS_PER_STEP = 3;
export const COMBO_MAX_MULTIPLIER = 5;
export const COMBO_FIRE_MULTIPLIER = 3;

export const START_LIVES = 3;
export const START_TIME = 30;
export const HIT_TIME_BONUS = 0.5;
export const LOW_TIME_THRESHOLD = 5;

export const MARKER_MIN_FROM_HAND = 30;
export const MARKER_MIN_FROM_OTHER = 24;

export const MAX_FRAME_DELTA_MS = 50;
export const CLOCK_SHAKE_DURATION = 0.3;
export const CLOCK_SHAKE_MAGNITUDE = 9;

export const SEEDS = {
  paper: 1091,
  face: 1811,
  hub: 2081,
  glow: 2371,
  timer: 2791,
  minuteHand: 2309,
  hourHand: 2311,
  minuteMarker: 3137,
  hourMarker: 3139,
  hearts: 4409,
  mascot: 4903,
  button: 5381,
  drifting: 5791,
  floating: 6217,
  game: 6703,
  share: 7013,
  speedButton: 7331,
  tutorial: 7451,
  flames: 7703,
  sideToggle: 7919,
  videoIcon: 8111,
  combo: 8291,
} as const;
